// extracted by mini-css-extract-plugin
export default {"container":"GoogleDriveBooks_container__Fex+u","lesson":"GoogleDriveBooks_lesson__KmKlP","event":"GoogleDriveBooks_event__B-7kY","arrow":"GoogleDriveBooks_arrow__z-PTr"};